export default function checkIsLending() {
  return !(window.location.host === 'boxberry.ru' || window.location.host.includes('task'));
}
